import React, { useEffect, useMemo, useRef } from 'react';
import { Line, Content } from './styles';
import Modal from '../index';
import { useDispatch, useSelector } from 'react-redux';
import ButtonComponent from '../../Button';
import { navigationUrl } from '../../../store/analytic/actions';

interface ICallNow {
  handlerClose: () => void;
}

function CallNow({ handlerClose }: ICallNow) {
  const configs = useSelector((state: ApplicationState) => state.config);
  const callRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useDispatch();
  const validateSaturdayTime = useMemo(
    () =>
      configs.startSaturdayAttendance &&
      configs.endSaturdayAttendance &&
      configs.startSaturdayAttendance !== '00:00' &&
      configs.endSaturdayAttendance !== '00:00',
    [configs]
  );

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/ligarAgora',
      })
    );
  }, [dispatch]);

  const handleClickCallNow = () => {
    if (callRef && callRef.current) callRef.current!.click();
  };

  const verifyIsInAttendance = (): boolean => {
    const today = new Date();
    const day = today.getDay();
    if (day > 0 && day < 6) {
      //dia de semana
      const date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number.parseInt(configs.endBusinessDayAttendance),
        0,
        0
      );
      return (
        today.getHours() >=
          Number.parseInt(configs.startBusinessDayAttendance) && today < date
      );
    }
    if (day === 6) {
      //sábado
      const date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number.parseInt(configs.endSaturdayAttendance),
        0,
        0
      );
      return (
        today.getHours() >= Number.parseInt(configs.startSaturdayAttendance) &&
        today < date
      );
    }
    return false;
  };

  return (
    <Modal
      title={'Ligar agora'}
      handlerClose={handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
    >
      <Content>
        <div className='container'>
          <div className='phoneDiv'>
            <span>Você poderá entrar em contato através do telefone:</span>
            <span className={'phone'}>{configs.assessoriaTelephone}</span>
          </div>
          <Line />
          <div className='attendanceDiv'>
            <span className={'fix'}>HORÁRIO DE FUNCIONAMENTO</span>
            <span className={'attendance'}>
              Seg a Sex de {configs.startBusinessDayAttendance}h às{' '}
              {configs.endBusinessDayAttendance}h
            </span>
            {validateSaturdayTime && (
              <span className={'attendance'}>
                Sábado de {configs.startSaturdayAttendance}h às{' '}
                {configs.endSaturdayAttendance}h
              </span>
            )}
          </div>
          {verifyIsInAttendance() && (
            <div className='buttonDiv'>
              <ButtonComponent
                height={60}
                onClick={handleClickCallNow}
                children={
                  <a
                    href={`tel:${configs.assessoriaTelephone}`}
                    className={'call'}
                    ref={callRef}
                  >
                    LIGAR AGORA
                  </a>
                }
                color={'primary'}
                fontSize={'16'}
                borderRadios={'16'}
              />
            </div>
          )}
        </div>
      </Content>
    </Modal>
  );
}

export default CallNow;
